// extracted by mini-css-extract-plugin
export default {"form":"CompA_form__boL2E","head":"CompA_head__MSlui","error":"CompA_error__A+km5"};